import type { ComponentProps } from 'react';
import { FieldInfo, hasFieldError, useFieldContext, useIsFieldOptional } from './shared';
import { useFormReadOnly } from './form-read-only';
import { FieldLabelRow } from './field-label-row';
import { MultiCombobox } from '../../custom/multi-combobox';
import { cn } from '../../lib/utils';

export default function MultiComboboxNumberField(
	props: ComponentProps<'select'> & {
		label: string;
		search: string;
		empty: string;
		options: { value: number; label: string }[];
		creatable?: boolean;
	},
) {
	const field = useFieldContext<number[]>();
	const formReadOnly = useFormReadOnly();
	const isOptional = useIsFieldOptional(field.name);

	return (
		<div
			className={cn(
				props.className,
				formReadOnly &&
					'pointer-events-none [&_[data-slot=combobox-chips]]:border-transparent [&_[data-slot=combobox-chips]]:px-0 [&_[data-slot=combobox-chips]]:focus-within:ring-0 [&_[data-slot=combobox-chip-input]]:min-w-0 [&_[data-slot=combobox-chip-input]]:flex-[0] [&_[data-slot=combobox-chip-input]]:opacity-0 [&_[data-slot=combobox-chip-input]]:overflow-hidden [&_[data-slot=combobox-chip-remove]]:opacity-0 [&_[data-slot=combobox-chip-remove]]:w-0 [&_[data-slot=combobox-chip-remove]]:-ml-2 [&_[data-slot=combobox-chip]]:h-auto [&_[data-slot=combobox-chip]]:px-0',
			)}
		>
			<div className="grid gap-2">
				{props.label && (
					<FieldLabelRow
						label={props.label}
						htmlFor={field.name}
						hasError={field.state.meta.isTouched && !field.state.meta.isValid}
						optional={isOptional}
					/>
				)}
				<MultiCombobox
					isError={hasFieldError(field.state.meta)}
					placeholder={props.label}
					commandEmpty={props.empty}
					searchPlaceholder={props.search}
					creatable={props.creatable}
					readOnly={formReadOnly}
					options={props.options.map((option) => ({
						value: option.value.toString(),
						label: option.label,
					}))}
					value={field.state.value?.map((value) => value.toString()) ?? []}
					onChange={(value) => field.handleChange(value.map(Number))}
				/>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
